<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    class="heroicon-identification heroicon heroicons-lg"
  >
    <path
      class="heroicon-identification-top heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M44 21H6a6 6 0 0 0-6 6v13h100V27a6 6 0 0 0-6-6H56v4a4 4 0 0 1 0 8H44a4 4 0 0 1 0-8v-4z"
    ></path>
    <path
      class="heroicon-identification-clip heroicon-component-fill"
      fill="#FFFFFF"
      d="M44 11h12v18H44V11zm6 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
    ></path>
    <path
      class="heroicon-identification-card"
      fill="#FFFFFF"
      d="M0 40h100v43a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V40z"
    ></path>
    <path
      class="heroicon-identification-photo-background heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M7 45v37h2v-8c0-1.1.8-2.4 1.8-2.9L17 68v-1.25A7 7 0 0 1 14 61v-4a7 7 0 1 1 14 0v4a7 7 0 0 1-3 5.75V68l6.2 3.1c1 .5 1.8 1.8 1.8 2.9v8h2V45H7z"
    ></path>
    <path
      class="heroicon-identification-photo-user-top heroicon-component-fill"
      fill="#FFFFFF"
      d="M17 68l-6.2 3.1C9.8 71.6 9 72.9 9 74v9h24v-9c0-1.1-.8-2.4-1.8-2.9L25 68v1a4 4 0 0 1-8 0v-1z"
    ></path>
    <path
      class="heroicon-identification-photo-user-face heroicon-component-fill"
      fill="#FFFFFF"
      d="M25 66.74V69a4 4 0 0 1-8 0v-2.25A7 7 0 0 1 14 61v-4a7 7 0 0 1 14 0v4a7 7 0 0 1-3 5.74z"
    ></path>
    <path
      class="heroicon-outline"
      fill="#4A4A4A"
      fill-rule="nonzero"
      d="M44 11h12v10h38a6 6 0 0 1 6 6v56a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V27a6 6 0 0 1 6-6h38V11zm2 2v14h8V13h-8zm-2 10H6a4 4 0 0 0-4 4v12h96V27a4 4 0 0 0-4-4H56v2a4 4 0 1 1 0 8H44a4 4 0 1 1 0-8v-2zm0 4a2 2 0 1 0 0 4h12a2 2 0 1 0 0-4v2H44v-2zm54 13H2v43a4 4 0 0 0 4 4h88a4 4 0 0 0 4-4V40zm-12 8v2H40v-2h46zm-10-4v2H40v-2h36zM40 82h10v1H40v-1zm12-2H40v-1h12v1zm0-4v1H40v-1h12zm16-12H40v-1h28v1zm-28-4h48v1H40v-1zm40-2H40v-1h40v1zm-4-4v1H40v-1h36zm-2 21h20v8H74v-8zm-45 8H6V44h30v39h-7zm18-66a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm28 59v6h18v-6H75zm-57-8.67V69a3 3 0 0 0 6 0v-1.67c-1.9.9-4.1.9-6 0zM7 45v37h2v-8c0-1.1.8-2.4 1.8-2.9L17 68v-1.25A7 7 0 0 1 14 61v-4a7 7 0 1 1 14 0v4a7 7 0 0 1-3 5.75V68l6.2 3.1c1 .5 1.8 1.8 1.8 2.9v8h2V45H7zm45-28a2 2 0 1 0-4 0 2 2 0 0 0 4 0zM21 73a4 4 0 0 1-4-4v.12L11.24 72A2.56 2.56 0 0 0 10 74v8h2v-6h1v6h16v-6h1v6h2v-8c0-.72-.6-1.68-1.24-2L25 69.12V69a4 4 0 0 1-4 4zm6-16a6 6 0 1 0-12 0v4a6 6 0 1 0 12 0v-4z"
    ></path>
  </svg>
</template>
